import styled, { css } from 'styled-components';
import palette from 'lib/styles/palette';
import { useLoginForm } from 'hooks/common/useLoginForm';
import logoSKShieldus from 'assets/logo-sk-shieldus.png';
import logoADT from 'assets/logo-adt.png';

const LoginForm = () => {
  const { username, password, errors, serverError, onChange, onSubmit } =
    useLoginForm();

  return (
    <LoginFormBlock>
      <Box>
        <img className="logo-adt" src={logoADT} alt="logo" width="280px" />
        <form>
          <StyledInput
            type="text"
            placeholder="ID"
            autoFocus
            value={username}
            name="username"
            onChange={onChange}
          />
          {errors.username && <ErrorMessage>{errors.username}</ErrorMessage>}
          <StyledInput
            type="password"
            placeholder="Password"
            value={password}
            name="password"
            onChange={onChange}
          />
          {errors.password && <ErrorMessage>{errors.password}</ErrorMessage>}
          {Object.keys(errors).length === 0 && serverError && (
            <ErrorMessage server>
              {serverError.includes('.') ? (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div style={{ textAlign: 'center' }}>
                    {serverError.split('.')[0]}
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    {serverError.split('.')[1]}
                  </div>
                </div>
              ) : (
                serverError
              )}
            </ErrorMessage>
          )}
          <StyledBtn onClick={onSubmit}>Login</StyledBtn>
          <img
            className="logo-sk"
            src={logoSKShieldus}
            alt="logo"
            width="100px"
          />
        </form>
        <div className="bottom">
          <a
            href="https://www.skshieldus.com/kor/policy/adtcaps.do"
            rel="noreferrer"
            target="_blank"
          >
            개인정보 처리방침
          </a>
          <div>고객센터 1588-6400</div>
        </div>
      </Box>
    </LoginFormBlock>
  );
};

export default LoginForm;

const LoginFormBlock = styled.div`
  height: 100%;
  background-color: ${palette.background};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Box = styled.div`
  width: 500px;
  padding-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.04);

  .logo-sk {
    margin-top: 15px;
  }

  .logo-adt {
    margin: 30px 0;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .bottom {
    display: flex;
    margin-top: 1.5rem;
    color: rgba(0, 0, 0, 0.2);

    a {
      color: rgba(0, 0, 0, 0.2);
      margin-right: 50px;
    }
  }

  .options-wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
    color: rgba(0, 0, 0, 0.4);
    font-size: 14px;

    div {
      cursor: pointer;
    }

    .options-left-wrapper {
      display: flex;
      align-items: center;

      div:last-child {
        margin-left: 5px;
      }
    }

    .options-right-wrapper {
      display: flex;

      span {
        margin: 0 5px;
      }
    }
  }
`;

const StyledInput = styled.input`
  width: 330px;
  height: 50px;
  border-radius: 11px;
  border: solid 1px #dfdfdf;
  background: #fff;
  padding: 15px;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
  & + & {
    margin-top: 15px;
  }
`;

const ErrorMessage = styled.div`
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  color: red;
  font-size: 12px;
  font-weight: 500;

  ${props =>
    props.server &&
    css`
      width: 250px;
      margin-top: 1rem;
    `}
`;

const StyledBtn = styled.button`
  width: 330px;
  height: 50px;
  border-radius: 11px;
  background: ${palette.theme[3]};
  font-weight: bold;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-top: 15px;
  &:hover {
    background: ${palette.theme[2]};
  }
`;
